import request from "@/utils/request.js"

// 场地-新增(跨租户)
export const addVenueIgnore = (formData) => {
    return request.post(`/venue/ignoreTenant`, formData)
}

// 场地-详情(跨租户)
export const getVenueIgnore = (id) => {
    return request.get(`/venue/ignoreTenant/${id}`)
}

// 场地-修改(跨租户)
export const updateVenueIgnore = (updateData) => {
    return request.put(`/venue/ignoreTenant`, updateData);
};
